export default {
      id: "map-usage",
      viewBox: "0 0 15 20",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#map",
      toString: function () {
        return this.url;
      }
    }